import { FC } from "react";
import { CSSReset, ChakraProvider } from "@chakra-ui/react";
import { Root } from "./modules/root/screens";

const App: FC = () => {
  return (
    <ChakraProvider>
      <CSSReset />
      <Root />
    </ChakraProvider>
  );
};

export default App;
